// Salvaged from ui-sprocket src/components/toast/toastContext.ts — reviewed 2026-09-21: unchanged.
import { createContext, useContext } from 'react';
const noop = () => { };
export const ToastContext = createContext({ success: noop, error: noop, info: noop });
/** Every action answers (§1.6): call one of these after every mutation. */
export function useToast() {
    return useContext(ToastContext);
}
//# sourceMappingURL=toast-context.js.map